import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons';
import { Button } from '@rocketlane/ui';
import styled from 'styled-components';

const PagePreviewHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  padding: var(--spacing-03);
`;

interface PreviewHeaderProps {
  onClose: () => void;
}

export const PreviewHeader: React.FC<PreviewHeaderProps> = ({ onClose }) => {
  return (
    <PagePreviewHeaderWrapper>
      <Button
        variant="secondary"
        size="medium"
        type="button"
        leftIcon={<FontAwesomeIcon icon={faChevronLeft} size={12} />}
        onClick={onClose}
      />
    </PagePreviewHeaderWrapper>
  );
};
